import { DefaultResponse } from '../interfaces/index';
import api from '../api';
import { AxiosResponse } from 'axios';

export interface ResponseUserInfo extends DefaultResponse {
  data: {
    id?: string;
    username?: string;
    department_id?: string;
    gender?: number;
    birthdate?: string;
    fullname?: string;
    address?: string;
    roles?: string[];
    institutions?: string[];
    title?: string;
    status?: number;
    creator_id?: string;
    signature?: string;
    created_at?: string;
    updated_at?: string;
    is_super?: boolean;
  };
}

export const getUserInfo = async () => {
  const response = (await api({
    url: '/users/v1/profile',
    method: 'GET',
    timeout: 30_000,
  })) as AxiosResponse<ResponseUserInfo>;
  const data = response?.data?.data || {};

  console.log(`🤡 CURRENT USER \n`, data);

  if (!window.dataLayer) {
    window.dataLayer = [];
  }

  window.dataLayer.push({
    event: 'login',
    username: data?.username,
    fullname: data?.fullname,
    is_super: data?.is_super,
  });

  return data;
};
